import { useRef } from 'react'
import { useTextPrompting } from './useTextPrompting'
import { FormikProvider } from 'formik'
import { StyledBody, StyledChatHeader, StyledRoot } from '../Cortext/Cortext'
import SettingsPortal from '../../components/SettingsPortal'
import ChatInput from '../../components/ChatInput'
import { StyledSettings } from '../Cortext/Settings/SettingsStyles.css'
import TextChatWindow from '../../components/TextChatWindow'
import SubnetDescription from '../../components/SubnetDescription'
import ChatHistoryList from '../../components/History/ChatHistoryList'
import Examples from '../../components/Examples'
import { examples } from './types'

const TextPrompting = () => {
    const {
        responseLoading,
        formik,
        chat,
        handleStartNewChat,
        chatHistory,
        setChat,
        handleDeleteHistory,
        scrollRef,
        handleStopRequest,
        requestLoading,
    } = useTextPrompting()

    const textPromptingRef = useRef(null)

    return (
        <FormikProvider value={formik}>
            <StyledRoot ref={textPromptingRef}>
                <ChatHistoryList
                    onNewChat={handleStartNewChat}
                    chatHistory={chatHistory}
                    handleDeleteHistory={handleDeleteHistory}
                    setChat={setChat}
                    chat={chat}
                />

                <StyledBody>
                    <StyledChatHeader />

                    <TextChatWindow
                        loading={responseLoading}
                        messages={chat.messages}
                        scrollRef={scrollRef}
                    />

                    <ChatInput
                        formik={formik}
                        fieldName='query'
                        stopRequest={{ requestLoading, handleStopRequest }}
                    />
                </StyledBody>
            </StyledRoot>

            <SettingsPortal portalRef={textPromptingRef}>
                <StyledSettings>
                    <SubnetDescription
                        noImage
                        title={'1. Text Prompting'}
                        description={'The Incentivized Internet'}
                        docUrl={`${import.meta.env.REACT_APP_SUBNET_DOCS_URL}/text-prompting`}
                    />

                    <Examples
                        noBorder
                        disabled={requestLoading}
                        formik={formik}
                        chatInputName={'query'}
                        examples={examples}
                    />
                </StyledSettings>
            </SettingsPortal>
        </FormikProvider>
    )
}

export default TextPrompting
